import { ArrowRight, CheckCircle2, Star, Phone, Sparkles, Shield, Clock, ChevronDown, Home, Droplet, Wind, CheckSquare } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Contact from '../components/Contact';

export default function Endreinigung() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const benefits = [
    'Professionelle Endreinigung – abzugsbereit',
    'Kaution-zurück-Garantie bei unserer Reinigung',
    'Erfahrene Reinigungskräfte mit Checkliste',
    'Umweltfreundliche Reinigungsmittel',
    'Abnahmeprotokoll für Vermieter inklusive',
    'Festpreis ohne versteckte Kosten',
  ];

  const cleaningAreas = [
    {
      icon: Home,
      title: 'Küche',
      items: [
        'Backofen komplett gereinigt',
        'Kühlschrank innen und aussen',
        'Kochfeld und Dunstabzugshaube',
        'Spüle und Armaturen',
        'Schränke innen und aussen',
        'Fliesen und Fugen',
        'Boden gewischt',
      ],
    },
    {
      icon: Droplet,
      title: 'Badezimmer',
      items: [
        'Toilette gründlich gereinigt',
        'Dusche / Badewanne inkl. Fugen',
        'Waschbecken und Armaturen',
        'Spiegel und Ablagen',
        'Fliesen komplett',
        'Entfernung von Kalkablagerungen',
        'Boden gewischt',
      ],
    },
    {
      icon: Wind,
      title: 'Alle Räume',
      items: [
        'Böden gesaugt und gewischt',
        'Fenster innen und aussen',
        'Fensterrahmen und -bänke',
        'Heizkörper',
        'Türen und Türrahmen',
        'Lichtschalter und Steckdosen',
        'Entfernung von Kleberesten',
      ],
    },
    {
      icon: CheckSquare,
      title: 'Extras',
      items: [
        'Balkon / Terrasse',
        'Kellerabteil',
        'Estrichraum',
        'Garage / Parkplatz',
        'Teppichreinigung',
        'Entfernung von Bohrlöchern',
        'Malerarbeiten auf Anfrage',
      ],
    },
  ];

  const pricingPackages = [
    {
      size: '1-2 Zimmer',
      area: 'bis 60m²',
      price: 'CHF 350.–',
      duration: '3-4 Stunden',
      included: [
        'Küche komplett',
        'Badezimmer komplett',
        'Alle Böden',
        'Alle Fenster',
        'Abnahmeprotokoll',
      ],
    },
    {
      size: '3-4 Zimmer',
      area: 'bis 100m²',
      price: 'CHF 550.–',
      duration: '5-6 Stunden',
      popular: true,
      included: [
        'Küche komplett',
        'Badezimmer komplett',
        'Alle Böden',
        'Alle Fenster',
        'Balkon',
        'Abnahmeprotokoll',
      ],
    },
    {
      size: '5-6 Zimmer',
      area: 'bis 150m²',
      price: 'CHF 850.–',
      duration: '7-9 Stunden',
      included: [
        'Küche komplett',
        '2x Badezimmer komplett',
        'Alle Böden',
        'Alle Fenster',
        'Balkon / Terrasse',
        'Keller / Estrich',
        'Abnahmeprotokoll',
      ],
    },
  ];

  const whyChooseUs = [
    {
      icon: Shield,
      title: 'Kaution-zurück-Garantie',
      description: 'Wir reinigen nach höchsten Standards. Falls die Abnahme nicht akzeptiert wird, bessern wir kostenlos nach – bis Sie Ihre Kaution zurückerhalten.',
    },
    {
      icon: CheckSquare,
      title: 'Professionelle Checkliste',
      description: 'Unsere Reinigungskräfte arbeiten nach einer umfassenden Checkliste, die alle Anforderungen von Vermietern abdeckt. Nichts wird vergessen.',
    },
    {
      icon: Sparkles,
      title: 'Erfahrene Spezialisten',
      description: 'Unser Team hat jahrelange Erfahrung mit Endreinigungen. Wir wissen genau, worauf Vermieter und Verwaltungen achten.',
    },
    {
      icon: Clock,
      title: 'Schnell & Zuverlässig',
      description: 'Wir reinigen termingerecht und pünktlich. Auch kurzfristige Termine sind oft möglich – sprechen Sie uns an.',
    },
  ];

  const checklist = [
    {
      area: 'Küche',
      items: [
        'Backofen entfettet und gereinigt',
        'Kühlschrank komplett sauber',
        'Schränke innen und aussen abgewischt',
        'Fliesen und Fugen sauber',
        'Keine Fettablagerungen',
        'Armaturen glänzend',
      ],
    },
    {
      area: 'Badezimmer',
      items: [
        'Keine Kalkablagerungen',
        'Fugen sauber und schimmelfrei',
        'Toilette hygienisch rein',
        'Armaturen glänzend',
        'Spiegel streifenfrei',
        'Abflüsse gereinigt',
      ],
    },
    {
      area: 'Wohnräume',
      items: [
        'Böden sauber gewischt',
        'Fenster innen und aussen',
        'Keine Klebereste oder Nägel',
        'Heizkörper staubfrei',
        'Lichtschalter sauber',
        'Keine Spinnweben',
      ],
    },
  ];

  const processSteps = [
    {
      step: '1',
      title: 'Besichtigung & Offerte',
      description: 'Wir besichtigen die Wohnung (vor Ort oder per Video) und erstellen eine transparente Festpreis-Offerte.',
    },
    {
      step: '2',
      title: 'Terminvereinbarung',
      description: 'Nach Ihrer Zusage vereinbaren wir den Reinigungstermin – idealerweise direkt nach dem Umzug.',
    },
    {
      step: '3',
      title: 'Professionelle Reinigung',
      description: 'Unser erfahrenes Team reinigt Ihre Wohnung nach Checkliste – von oben bis unten.',
    },
    {
      step: '4',
      title: 'Abnahmeprotokoll',
      description: 'Sie erhalten ein detailliertes Abnahmeprotokoll mit allen durchgeführten Reinigungsarbeiten.',
    },
    {
      step: '5',
      title: 'Kaution zurück',
      description: 'Übergeben Sie die Wohnung mit gutem Gewissen – die Kaution sollte problemlos zurückfließen.',
    },
  ];

  const testimonials = [
    {
      name: 'Sarah L.',
      location: 'Zürich',
      text: 'Die Wohnung war blitzsauber! Der Vermieter hatte nichts zu bemängeln und die Kaution kam komplett zurück. Super Service!',
      rating: 5,
    },
    {
      name: 'Marco B.',
      location: 'Basel',
      text: 'Ich hatte keine Zeit für die Endreinigung. Das Team hat alles perfekt gemacht – sogar den Backofen der aussah wie neu!',
      rating: 5,
    },
    {
      name: 'Familie Weber',
      location: 'Bern',
      text: 'Sehr professionell und gründlich. Die Checkliste wurde komplett abgearbeitet. Kann ich nur empfehlen!',
      rating: 5,
    },
  ];

  const faqs = [
    {
      question: 'Was kostet eine professionelle Endreinigung?',
      answer: 'Die Kosten hängen von der Grösse der Wohnung ab:<br><br>• <strong>1-2 Zimmer (bis 60m²):</strong> ab CHF 350.–<br>• <strong>3-4 Zimmer (bis 100m²):</strong> ab CHF 550.–<br>• <strong>5-6 Zimmer (bis 150m²):</strong> ab CHF 850.–<br><br>Zusatzleistungen wie Teppichreinigung, Kellerreinigung oder Entfernung von Bohrlöchern werden separat berechnet. Nach einer Besichtigung erhalten Sie einen transparenten Festpreis.'
    },
    {
      question: 'Was ist alles in der Endreinigung enthalten?',
      answer: 'Unsere Standard-Endreinigung umfasst:<br><br><strong>Küche:</strong> Backofen, Kühlschrank, Schränke, Fliesen, Armaturen, Boden<br><strong>Badezimmer:</strong> Toilette, Dusche/Wanne, Waschbecken, Spiegel, Fliesen, Fugen<br><strong>Alle Räume:</strong> Böden, Fenster (innen & aussen), Heizkörper, Türen, Lichtschalter<br><br>Optional: Balkon, Keller, Estrich, Garage, Teppichreinigung, Malerarbeiten.<br><br>Sie erhalten ein Abnahmeprotokoll mit allen durchgeführten Arbeiten.'
    },
    {
      question: 'Bekomme ich garantiert meine Kaution zurück?',
      answer: 'Wir bieten eine <strong>Kaution-zurück-Garantie</strong>: Wenn Ihr Vermieter die Reinigung nicht akzeptiert, bessern wir <strong>kostenlos nach</strong> – so oft bis die Wohnung abgenommen wird. In über 98% der Fälle wird unsere Reinigung beim ersten Mal akzeptiert. Sollte dennoch etwas bemängelt werden, sind wir sofort für Sie da.'
    },
    {
      question: 'Wie lange dauert eine Endreinigung?',
      answer: 'Die Dauer hängt von der Wohnungsgrösse ab:<br><br>• <strong>1-2 Zimmer:</strong> 3-4 Stunden<br>• <strong>3-4 Zimmer:</strong> 5-6 Stunden<br>• <strong>5-6 Zimmer:</strong> 7-9 Stunden<br><br>Bei stark verschmutzten Wohnungen kann es länger dauern. Wir arbeiten mit einem professionellen Team, sodass die Reinigung effizient und gründlich erfolgt.'
    },
    {
      question: 'Kann ich die Endreinigung auch kurzfristig buchen?',
      answer: 'Ja, kurzfristige Termine sind oft möglich! Wir empfehlen jedoch eine Vorlaufzeit von <strong>1-2 Wochen</strong> für optimale Planungssicherheit. Bei dringenden Anfragen versuchen wir immer, eine Lösung zu finden – auch innerhalb von 2-3 Tagen.<br><br>Für <strong>Express-Reinigungen</strong> (innerhalb 24-48h) berechnen wir einen Aufpreis von 20%. Rufen Sie uns einfach an: 0800 700 100'
    },
    {
      question: 'Muss ich während der Reinigung anwesend sein?',
      answer: 'Nein, Sie müssen <strong>nicht anwesend sein</strong>. Viele unserer Kunden übergeben uns die Schlüssel und wir reinigen in ihrer Abwesenheit. Das ist besonders praktisch, wenn Sie bereits umgezogen sind.<br><br>Ablauf:<br>1. Sie hinterlegen die Schlüssel (z.B. in Briefkasten mit Code)<br>2. Wir reinigen die Wohnung<br>3. Sie erhalten Fotos der gereinigten Räume<br>4. Wir hinterlegen die Schlüssel wieder oder übergeben sie Ihrem Vermieter'
    },
    {
      question: 'Was passiert, wenn der Vermieter die Reinigung nicht akzeptiert?',
      answer: 'Falls Ihr Vermieter Mängel feststellt, bessern wir <strong>kostenlos und sofort nach</strong>. Das ist unsere Kaution-zurück-Garantie. In den letzten Jahren hatten wir eine Erfolgsquote von über 98% – die meisten Wohnungen werden beim ersten Mal abgenommen.<br><br>Falls doch etwas bemängelt wird:<br>• Kontaktieren Sie uns sofort<br>• Wir kommen innerhalb 24-48h vorbei<br>• Wir beheben die Mängel kostenlos<br>• Sie bekommen Ihre Kaution'
    },
    {
      question: 'Verwendet ihr umweltfreundliche Reinigungsmittel?',
      answer: 'Ja, wir verwenden wo immer möglich <strong>biologisch abbaubare und umweltfreundliche Reinigungsmittel</strong>. Diese sind:<br><br>• Frei von aggressiven Chemikalien<br>• Hautfreundlich<br>• Effektiv gegen Schmutz und Kalk<br>• Geruchsneutral<br><br>Für hartnäckige Verschmutzungen (z.B. Backofenreinigung) setzen wir professionelle Spezialreiniger ein, die jedoch ebenfalls umweltverträglich sind.'
    },
    {
      question: 'Kann ich die Endreinigung mit dem Umzug kombinieren?',
      answer: 'Ja, das ist sogar <strong>sehr empfehlenswert</strong>! Bei Buchung von <Link to="/komplettumzug" className="text-slate-900 font-semibold hover:underline">Umzug</Link> + Endreinigung profitieren Sie von:<br><br>• <strong>Sonderpreis:</strong> 10% Rabatt auf die Endreinigung<br>• <strong>Koordination:</strong> Alles aus einer Hand<br>• <strong>Zeitersparnis:</strong> Wir reinigen direkt nach dem Auszug<br>• <strong>Stressfrei:</strong> Sie müssen sich um nichts kümmern<br><br>Das ist die beliebteste Option unserer Kunden bei <Link to="/umzug-zuerich-deutschland" className="text-slate-900 font-semibold hover:underline">Umzügen Zürich Deutschland</Link> und anderen Routen – sprechen Sie uns darauf an!'
    },
    {
      question: 'Reinigt ihr auch nach einem Umzug von der Schweiz nach Deutschland?',
      answer: 'Ja, absolut! Wir reinigen Ihre <strong>alte Wohnung in der Schweiz</strong>, nachdem Sie nach Deutschland umgezogen sind. Das ist besonders praktisch bei einem <Link to="/umzug-basel-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Basel Deutschland</Link> oder <Link to="/umzug-bern-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Bern Deutschland</Link>, wenn Sie bereits in Deutschland sind und nicht extra zurückreisen möchten.<br><br>Ablauf:<br>1. Besichtigung vorab (oder per Video/Fotos)<br>2. Festpreis-Offerte<br>3. Reinigung nach dem Auszug<br>4. Fotos der gereinigten Wohnung<br>5. Abnahmeprotokoll<br><br>Sie können entspannt in Deutschland einleben – wir kümmern uns um den Rest!'
    }
  ];

  const extras = [
    { name: 'Teppichreinigung', price: 'ab CHF 80.–' },
    { name: 'Kellerabteil', price: 'ab CHF 60.–' },
    { name: 'Estrichraum', price: 'ab CHF 60.–' },
    { name: 'Garage / Parkplatz', price: 'ab CHF 50.–' },
    { name: 'Balkon / Terrasse', price: 'ab CHF 40.–' },
    { name: 'Bohrlöcher schliessen', price: 'CHF 8.–/Loch' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20 min-h-[700px] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-white/20">
              Professionelle Endreinigung
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Endreinigung – Abzugsbereit
            </h1>

            <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
              Professionelle Endreinigung mit Kaution-zurück-Garantie – stressfrei Ihre Kaution sichern
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button
                onClick={scrollToContact}
                className="bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>Gratis Offerte erhalten</span>
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="tel:0800700100"
                className="bg-slate-700/50 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-700 transition-all duration-300 border border-white/20 flex items-center justify-center space-x-2"
              >
                <Phone className="w-5 h-5" />
                <span>0800 700 100</span>
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              {benefits.slice(0, 3).map((benefit, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <CheckCircle2 className="w-6 h-6 text-green-400 mb-2 mx-auto" />
                  <p className="text-sm font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Was ist eine Endreinigung?
              </h2>
              <p className="text-xl text-slate-600 leading-relaxed">
                Eine Endreinigung ist die gründliche Reinigung Ihrer alten Wohnung nach dem Auszug – damit Sie sie in <strong>abzugsbereitem Zustand</strong> übergeben können. Eine professionelle Endreinigung stellt sicher, dass Ihr Vermieter die Wohnung ohne Beanstandungen übernimmt und Sie Ihre <strong>Kaution vollständig zurückerhalten</strong>. Perfekt kombinierbar mit unserem <Link to="/komplettumzug" className="text-slate-900 font-semibold hover:underline">Komplettumzug</Link> für stressfreien Umzug.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-200">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Alle Vorteile auf einen Blick:
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
                    <span className="text-slate-700">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Was wird gereinigt?
              </h2>
              <p className="text-xl text-slate-600">
                Umfassende Reinigung aller Bereiche
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {cleaningAreas.map((area, index) => {
                const Icon = area.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">{area.title}</h3>
                    <ul className="space-y-2">
                      {area.items.map((item, idx) => (
                        <li key={idx} className="flex items-start space-x-2">
                          <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                          <span className="text-slate-600">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Preise Endreinigung
              </h2>
              <p className="text-xl text-slate-600">
                Transparente Festpreise für jede Wohnungsgrösse
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {pricingPackages.map((pkg, index) => (
                <div
                  key={index}
                  className={`rounded-2xl p-8 border-2 transition-all duration-300 ${
                    pkg.popular
                      ? 'bg-slate-900 border-slate-900 text-white scale-105'
                      : 'bg-slate-50 border-slate-200 hover:border-slate-800'
                  }`}
                >
                  {pkg.popular && (
                    <div className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
                      BELIEBTESTE GRÖSSE
                    </div>
                  )}
                  <h3 className={`text-2xl font-bold mb-2 ${pkg.popular ? 'text-white' : 'text-slate-900'}`}>
                    {pkg.size}
                  </h3>
                  <p className={`text-sm mb-4 ${pkg.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                    {pkg.area}
                  </p>
                  <div className={`text-4xl font-bold mb-2 ${pkg.popular ? 'text-white' : 'text-slate-900'}`}>
                    {pkg.price}
                  </div>
                  <p className={`text-sm mb-6 ${pkg.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                    Dauer: {pkg.duration}
                  </p>
                  <div className={`border-t mb-6 ${pkg.popular ? 'border-slate-700' : 'border-slate-300'}`} />
                  <ul className="space-y-3">
                    {pkg.included.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle2
                          className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                            pkg.popular ? 'text-green-400' : 'text-green-600'
                          }`}
                        />
                        <span className={`text-sm ${pkg.popular ? 'text-slate-200' : 'text-slate-700'}`}>
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={scrollToContact}
                    className={`w-full mt-8 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                      pkg.popular
                        ? 'bg-white text-slate-900 hover:bg-slate-100'
                        : 'bg-slate-900 text-white hover:bg-slate-800'
                    }`}
                  >
                    Offerte anfordern
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-12">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Zusatzleistungen
              </h3>
              <div className="grid md:grid-cols-3 gap-4">
                {extras.map((extra, index) => (
                  <div key={index} className="bg-slate-50 rounded-xl p-4 border border-slate-200 flex justify-between items-center">
                    <span className="text-slate-700">{extra.name}</span>
                    <span className="font-bold text-slate-900">{extra.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Warum Endreinigung bei uns?
              </h2>
              <p className="text-xl text-slate-600">
                Ihr Garant für eine erfolgreiche Wohnungsabgabe
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {whyChooseUs.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-lg">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{item.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{item.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Unsere Reinigungscheckliste
              </h2>
              <p className="text-xl text-slate-600">
                Damit nichts vergessen wird
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {checklist.map((section, index) => (
                <div key={index} className="bg-slate-50 rounded-2xl p-6 border-2 border-slate-100">
                  <h3 className="text-xl font-bold text-slate-900 mb-4">{section.area}</h3>
                  <ul className="space-y-2">
                    {section.items.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle2 className="w-4 h-4 text-green-600 flex-shrink-0 mt-1" />
                        <span className="text-sm text-slate-600">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                So läuft die Endreinigung ab
              </h2>
              <p className="text-xl text-slate-600">
                5 Schritte zur sauberen Wohnung
              </p>
            </div>

            <div className="grid md:grid-cols-5 gap-6">
              {processSteps.map((step, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 border-2 border-slate-100">
                  <div className="bg-slate-900 text-white w-12 h-12 rounded-xl flex items-center justify-center font-bold text-xl mb-4">
                    {step.step}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-3">{step.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Das sagen unsere Kunden
              </h2>
              <p className="text-xl text-slate-600">
                Zufriedene Kunden – zurückerhaltene Kautionen
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-slate-50 rounded-2xl p-6 border-2 border-slate-100">
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 leading-relaxed">"{testimonial.text}"</p>
                  <div className="border-t border-slate-200 pt-4">
                    <div className="font-semibold text-slate-900">{testimonial.name}</div>
                    <div className="text-sm text-slate-500">{testimonial.location}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Häufig gestellte Fragen
              </h2>
              <p className="text-xl text-slate-600">
                Alles über professionelle Endreinigung
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl border-2 border-slate-100 overflow-hidden transition-all duration-300 hover:border-slate-300"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left"
                  >
                    <span className="font-semibold text-slate-900 pr-4">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-slate-600 transition-transform duration-300 flex-shrink-0 ${
                        openFaq === index ? 'transform rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-5">
                      <p className="text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Contact />
    </div>
  );
}
